import { useEffect, useRef } from "react";
import embed from "vega-embed";
import type { ChartArtifact } from "./types";

export function ChartArtifactView({ artifact }: { artifact: ChartArtifact }) {
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!ref.current) return;
    let cancelled = false;
    embed(ref.current, artifact.vega_lite_spec as object, {
      actions: { export: true, source: false, compiled: false, editor: false },
      renderer: "svg",
    }).catch((err) => {
      if (!cancelled && ref.current) {
        ref.current.textContent = `chart render error: ${String(err)}`;
      }
    });
    return () => {
      cancelled = true;
    };
  }, [artifact.vega_lite_spec]);

  return (
    <div className="artifact">
      <div ref={ref} />
    </div>
  );
}
